import React from 'react';
import styled from 'styled-components';

interface LabelProps {
  children: React.ReactNode;
  htmlFor?: string;
  className?: string;
}

const StyledLabel = styled.label`
  font-size: ${props => props.theme.textSm};
  font-weight: ${props => props.theme.fontMedium};
  color: ${props => props.theme.foreground};
  margin-bottom: 8px;
  display: block;
  line-height: 1.4;
`;

export const Label: React.FC<LabelProps> = ({ 
  children, 
  htmlFor, 
  className 
}) => {
  return (
    <StyledLabel htmlFor={htmlFor} className={className}>
      {children}
    </StyledLabel>
  );
};
